import { render, staticRenderFns } from "./UserMyEmails.vue?vue&type=template&id=4867f1fd"
import script from "./UserMyEmails.vue?vue&type=script&lang=js"
export * from "./UserMyEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports